export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/bike/resources/components.js